module.exports = __webpack_public_path__ + "static/img/contact_mf.ca33e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact_mf.png
// module id = op6n
// module chunks = 94